import React, {useState} from 'react';
import {Link, Redirect} from 'react-router-dom';

function Home({roll, setRoll, data, setData}) {
  
  const [redirect, setRedirect] = useState(false)


  const handleSubmit = e => {
    e.preventDefault()

    let tempRoll = roll.limits[0];
    let newRegister = {}
    for(let i = 0; i < roll.limits[1] - roll.limits[0] + 1; i++) {
      newRegister[ tempRoll ] = {num: tempRoll, present: false}
      tempRoll++
    }
    roll.register = newRegister;

    setRoll(roll);
    setRedirect(true)
    console.log(redirect ,roll);

  }
  // const handleIncrement = (e) => {
  //   setTest( [test[0]+1] )
  // }

  return redirect? <Redirect to="/rollCall"/>:(
    <div>
     { //<p> Test: { test[0] } </p>
         //  <button onClick = { handleIncrement }>Increase</button>
       }
      <form onSubmit = { handleSubmit }>
        
        <div className = "data-entry">
          <div>
            <label>Lecture</label>
            <input className="num-input"
              name="Lecture" 
              type="number" 
              min="1" 
              placeholder="Lecture Number" 
              onChange = {e => data.lecture = parseInt(e.target.value)}
              // onChange = {e => setRoll(1)}
              required/>
          </div>
          <div>
            <label>Class  </label>
            <input className="num-input"
              name="Class" 
              type="number" 
              min="1" 
              placeholder="Class" 
              onChange = {e => data.class = parseInt(e.target.value)}
              required/>
          </div>
          <div>
            <label>Section  </label>
            <input className="num-input"
              name="Section" 
              type="text"  
              placeholder="Section" 
              onChange = {e => data.section = e.target.value}
              required/>
          </div>
          <div>
            <label>Subject  </label>
            <input className="num-input"
              name="Subject" 
              type="text"  
              placeholder="Subject" 
              onChange = {e => data.subject = e.target.value}
              required/>
          </div>

        </div>
        <br/> <br/>
        <div className="limits">
          <div>  
            <label>First Roll Number  </label>    
            <input className="num-input"
              name="first" 
              type="number" 
              min="1" 
              placeholder="First roll no." 
              onChange = {e => roll.limits[0] = parseInt(e.target.value)}
              // onChange = {e => setRoll(1)}
              required/>
          </div>
          <div>
            <label>Last Roll Number  </label>  
            <input className="num-input"
              name="last" 
              type="number" 
              min="2" 
              placeholder="Last roll no." 
              onChange = {e => roll.limits[1] = parseInt(e.target.value)}
              required/>
          </div>
          <div>
            <input type="submit" value="submit" className="submit"/>
          </div>
        </div>

      </form>


    </div>
  );
}

export default Home;
